<!-- 新增实操 -->
<template>
    <div class="el-AddPractical">
        <el-row class="content_block">
            <TitleInfo title="新增实操" :titleImg="ct_b"></TitleInfo>
            <el-row class="p20" style="min-height: 320px;overflow: auto;">
                <el-form ref="form" :model="form" label-width="80px">
                    <el-form-item label="归属课程">
                        <el-select @change="getCourseInfoList" clearable v-model="form.teacherOpenCourseId"
                            placeholder="请选择归属课程">
                            <template v-for="(item, index) in courseList">
                                <el-option :label="item.teacherOpenCourseIdText || item.teacherOpenCourseTitle"
                                    :value="item.teacherOpenCourseId"></el-option>
                            </template>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="归属章节">
                        <el-select clearable v-model="form.courseChildNode" placeholder="请选择归属章节">
                            <template v-for="(item, index) in courseInfoList">
                                <el-option :label="item.courseInfoName"
                                    :value="item.teacherOpenCourseMergeCourseInfoId"></el-option>
                            </template>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="案例名称">
                        <el-input style="width: 50%;" placeholder="请输入案例名称" v-model="form.handsOnName"></el-input>
                    </el-form-item>
                    <el-form-item label="案列介绍">
                        <el-row style="width: 50%;">
                            <RichText ref="richText" v-model="form.handsOnRecommend" />
                        </el-row>
                    </el-form-item>
                    <el-form-item label="数据集">
                        <el-row style="width: 50%;">
                            <UploadFiles ref="picture" v-if="pictureShow" :fileLists="form.trainingData || []"
                                @onSuccess="value => form.trainingData = value" />
                        </el-row>
                    </el-form-item>
                    <template v-if="!$isEmpty(handsOnId)">
                        <el-form-item label="实训任务">
                            <el-button type="primary" icon="el-icon-plus" @click="addTask"></el-button>
                        </el-form-item>
                        <el-form-item label="">
                            <el-table :data="tableData" border style="width: 50%">
                                <el-table-column type="index" header-align="center" align="center" width="100"
                                    label="任务顺序"></el-table-column>
                                <el-table-column prop="taskTitle" header-align="center" align="center" label="任务标题">
                                </el-table-column>
                                <el-table-column prop="taskType" header-align="center" align="center" label="任务类型">
                                    <template slot-scope="scope">{{ $retTaskName(scope.row.taskType) }}</template>
                                </el-table-column>
                                <el-table-column prop="taskScore" header-align="center" align="center" label="分值"
                                    width="120"> </el-table-column>
                                <el-table-column prop="user_" header-align="center" align="center" label="操作"
                                    width="180">
                                    <template slot-scope="scope">
                                        <el-link type="primary" class="mr20" :underline="false"
                                            @click="editInfo(scope.row)">编辑</el-link>
                                        <el-link type="primary" :underline="false"
                                            @click="delInfo(scope.row, scope.$index)">删除</el-link>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-form-item>
                    </template>
                </el-form>
                <el-row class="t_r" style="width: 50%;">
                    <span style="margin-right: 20px;color: #a3a5a7;" v-if="$isEmpty(handsOnId)">
                        <i class="el-icon-info"></i>保存后可继续添加实训任务
                    </span>
                    <el-button @click="closePage">取 消</el-button>
                    <el-button type="primary" @click="submitInfo">保 存</el-button>
                </el-row>
            </el-row>

            <!-- 添加实训任务 -->
            <el-dialog title="添加实训任务" :visible.sync="addTaskShow" width="1000px">
                <span slot="title">
                    <i class="el-icon-s-check" style="margin-right: 10px;color: #67C23A;"></i>添加实训任务
                </span>
                <el-form ref="form" :model="taskInfoForm" label-width="100px">
                    <el-form-item label="任务类型">
                        <el-radio-group v-model="taskInfoForm.taskType">
                            <el-radio :disabled="!$isEmpty(taskInfoForm.taskId)" label="1">观看视频</el-radio>
                            <el-radio :disabled="!$isEmpty(taskInfoForm.taskId)" label="2">观看PPT</el-radio>
                            <el-radio :disabled="!$isEmpty(taskInfoForm.taskId)" label="3">理论测评</el-radio>
                            <el-radio :disabled="!$isEmpty(taskInfoForm.taskId)" label="4">实训操作步骤</el-radio>
                            <el-radio :disabled="!$isEmpty(taskInfoForm.taskId)" label="5">报告撰写</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="任务标题">
                        <el-input v-model="taskInfoForm.taskTitle"></el-input>
                    </el-form-item>
                    <el-form-item label="分值"
                        v-if="taskInfoForm.taskType == 1 || taskInfoForm.taskType == 2 || taskInfoForm.taskType == 5">
                        <el-input v-model="taskInfoForm.taskScore"></el-input>
                    </el-form-item>
                    <el-form-item label="任务顺序">
                        <el-input v-model="taskInfoForm.taskOrder"></el-input>
                    </el-form-item>
                    <el-form-item label="客观题设置" v-if="taskInfoForm.taskType == 3">
                        <el-button type="primary" @click="selectQuestion">题库选择</el-button>
                        <el-table :data="tableQuestionData" border ref="tableQuestion" show-summary
                            :summary-method="getSummaries" :span-method="arraySpanMethod"
                            style="width: 100%;margin-top: 10px;">
                            <el-table-column prop="questionTypeName" header-align="center" align="center" label="题型">
                                <template slot-scope="scope">{{ $retQuestionType(scope.row.questionType) }}</template>
                            </el-table-column>
                            <el-table-column prop="questionNum" header-align="center" align="center" label="选题量">
                            </el-table-column>
                            <el-table-column prop="questionScore" header-align="center" align="center" label="分值">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.questionScore"
                                        @change="changeInfo(scope.row, scope.$index)" placeholder="请输入分值"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="questionTotal" header-align="center" align="center" label="合计">
                            </el-table-column>
                        </el-table>
                    </el-form-item>
                    <el-form-item label="考核内容" v-if="taskInfoForm.taskType == 4">
                        <editorMd editorId="editorAssessmentContent" v-if="taskInfoForm.taskType == 4"
                            @onChangeContent="changeValue" :modelValue="taskInfoForm.assessmentContent"></editorMd>
                    </el-form-item>
                    <el-form-item label="报告要求" v-if="taskInfoForm.taskType == 5">
                        <RichText ref="richText5" v-if="taskInfoForm.taskType == 5"
                            v-model="taskInfoForm.assessmentContent" />
                    </el-form-item>
                    <el-form-item label="考核题目" v-if="taskInfoForm.taskType == 4">
                        <span style="color: red;">【注】需要考核的内容用 [---] 替换</span>
                        <!-- <el-button type="primary" style="margin-bottom: 10px;" icon="el-icon-circle-plus-outline" @click="addSubject()"></el-button> -->
                        <el-table border ref="table" :data="tableData4" style="width: calc(100% - 20px);">
                            <el-table-column prop="handsOnSimulationTasksAssessmentQuestion" header-align="center"
                                align="center" label="考核题目" width="120px">
                                <!-- <template slot-scope="scope">
                  <el-input type="text" :rows="3" placeholder="题目" v-model="scope.row.handsOnSimulationTasksAssessmentQuestion"></el-input>
                </template> -->
                            </el-table-column>
                            <el-table-column prop="handsOnSimulationTasksAssessmentScore" header-align="center"
                                align="center" label="分值" width="120px">
                                <template slot-scope="scope">
                                    <el-input :rows="3" placeholder="分值"
                                        v-model="scope.row.handsOnSimulationTasksAssessmentScore"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="handsOnSimulationTasksAssessmentAnswer" header-align="center"
                                align="center" label="考核答案">
                                <template slot-scope="scope">
                                    <el-input type="textarea" :rows="3" placeholder="请输入考核答案"
                                        v-model="scope.row.handsOnSimulationTasksAssessmentAnswer"></el-input>
                                </template>
                            </el-table-column>
                            <!-- <el-table-column prop="hj" header-align="center" align="center" label="操作" width="100px">
                <template slot-scope="scope">
                  <el-button type="danger" @click="delSubject(scope.$index)">删除</el-button>
                </template>
              </el-table-column> -->
                        </el-table>
                    </el-form-item>
                    <el-form-item label="考核要求" v-if="taskInfoForm.taskType == 1 || taskInfoForm.taskType == 2">
                        <label>至少观看：</label>
                        <el-input style="width: 80px;margin-right: 10px;"
                            v-model="taskInfoForm.assessmentRequirements"></el-input>分钟
                        <label class="ml50">间隔多少分钟出现一次弹窗：</label>
                        <el-input style="width: 80px;margin-right: 10px;"
                            v-model="taskInfoForm.assessmentTime"></el-input>分钟
                    </el-form-item>
                    <el-form-item :label="taskInfoForm.taskType == 5 ? '报告参考模板' : taskInfoForm.taskType == 2 ? '添加文档' : '添加视频'"
                        v-if="taskInfoForm.taskType == 1 || taskInfoForm.taskType == 2 || taskInfoForm.taskType == 5">
                        <UploadFiles ref="taskPicture"
                            :fileLists="taskInfoForm.teacherOpenCourseHandsOnSimulationTasksFileList" v-if="addTaskShow"
                            :isPdf="taskInfoForm.taskType == 5 ? false : true" @onSuccess="taskInfoSuccess" />
                        <el-button type="warning" v-if="taskInfoForm.taskType == 1 || taskInfoForm.taskType == 2"
                            style="position: absolute;top: 5px;left: 100px;" @click="openResourceLibrary"
                            size="small">资源库选择</el-button>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="addTaskShow = false">取 消</el-button>
                    <el-button type="primary" @click="submitAddTask">确 认</el-button>
                </span>
            </el-dialog>

            <!-- 选择题库 -->
            <Question :show="seeQuestionShow" @closeDialog="value => seeQuestionShow = true"
                @onSuccess="questionSuccess" :courseId="courseId" :onIds="taskInfoForm.taskList" v-if="seeQuestionShow"
                :handsOnId="handsOnId">
            </Question>

            <!-- 资源库上传 -->
            <el-dialog title="资源库上传" :visible.sync="uploadPoolShow" width="800px">
                <el-row>
                    <el-row>
                        <label>资源名称：</label>
                        <el-input style="width: 200px;" v-model="poolSearch.name" placeholder="请输入资源名称"></el-input>
                        <label class="ml20">归属课程：</label>
                        <el-select v-model="poolSearch.courseInfoId" placeholder="请选择归属课程">
                            <template v-for="(item, index) in courseImportList">
                                <el-option :label="item.courseInfoName" :value="item.courseInfoId"></el-option>
                            </template>
                        </el-select>
                        <el-button type="primary" icon="el-icon-search" @click="getPoolInfo(page = 1)">搜索</el-button>
                    </el-row>
                    <el-table :data="tablePool" border style="width: 100%;margin-top: 10px;">
                        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
                        <el-table-column prop="resourcesInfoName" header-align="center" align="center" label="资源名称">
                        </el-table-column>
                        <el-table-column prop="courseInfoParentParentName" header-align="center" align="center"
                            label="归属课程">
                        </el-table-column>
                        <el-table-column prop="resourcesInfoType" header-align="center" align="center" label="资源类型">
                            <template slot-scope="scope">
                                {{ $retRresourcesName(scope.row.resourcesInfoType) }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="user_" header-align="center" align="center" label="操作" width="120">
                            <template slot-scope="scope">
                                <el-link type="primary" :underline="false" @click="lookPoolInfo(scope.row)">查看</el-link>
                                <el-link type="primary" :underline="false"
                                    @click="selectPoolInfo(scope.row)">选择</el-link>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="block" style="text-align: right;bottom: 0;width: 96%;margin: 20px;">
                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                            :current-page.sync="page" :page-sizes="[10, 20, 50, 100]" :page-size="limit" background
                            :hide-on-single-page="true" layout="sizes, prev, pager, next,jumper" :total="total">
                        </el-pagination>
                    </div>
                </el-row>
                <!-- <span slot="footer" class="dialog-footer">
          <el-button @click="uploadPoolShow = false">取 消</el-button>
          <el-button type="primary" @click="submitUploadPool">确 定</el-button>
        </span> -->
            </el-dialog>
        </el-row>
    </div>
</template>

<script>
import TitleInfo from "@/components/TitleInfo"	//页面头部
import RichText from '@/components/RichText/index'
import Question from '@/components/Question/index'
import { getCourseList, getCourseInfoList } from "@/common/getInfo"	//加载数据
import UploadFiles from "@/components/UploadFiles"	//上传
import { loadJs } from '@/common/actions.js'
import editorMd from "@/components/editorMd/index"	//编辑器
export default {
    name: "AddPractical",
    components: {
        TitleInfo,
        RichText,
        Question,
        UploadFiles,
        editorMd
    },
    data() {
        return {
            courseId: this.$route.query.courseId, //开课ID
            handsOnId: this.$route.query.handsOnId, //实操ID
            ct_b: require("../../images/course/ct_b@2x.png"),
            form: {
                teacherOpenCourseId: '', //归属课程
                courseChildNode: '',//归属章节
                handsOnName: '',//实操名称
                handsOnRecommend: '',//实操介绍
                trainingData: '',//数据集
            },
            tableData: [],
            tableQuestionData: [],
            tableData4: [],
            addTaskShow: false,
            taskInfoForm: { //实训任务表单信息
                taskType: "1", //1:视频 2:ppt 3:理论 4:实操 5:报告
            },
            seeQuestionShow: false,
            courseList: [],
            courseInfoList: [],
            pictureShow: false,
            uploadPoolShow: false, //资源库上传
            courseImportList: [],
            tablePool: [],
            total: 0,
            limit: 10,
            page: 1,
            poolSearch: {
                courseInfoId: null,
                name: null
            }
        }
    },
    created() {
        loadJs()
        this.getCourseList()
    },
    mounted() {
        this.getInfo()
        this.getPageList()
    },
    methods: {
        getInfo() { //获取信息
            if (!this.$isEmpty(this.handsOnId)) {
                this.$get("/api/teacherOpenCourseHandsOn/getInfo.do", { handsOnId: this.handsOnId }).then((ret) => {
                    if (ret.code == 0) {
                        this.form = ret.data
                        this.$refs.richText.content = ret.data.handsOnRecommend //编辑框内容
                        this.form.trainingData = JSON.parse(this.form.trainingData)
                        this.getCourseInfoList()
                        this.pictureShow = true
                    } else {
                        this.$message({ message: ret.msg, type: 'error' })
                    }
                })
            } else {
                this.pictureShow = true
            }
        },
        submitInfo() {
            if (this.$isEmpty(this.form.teacherOpenCourseId)) {
                this.$message({ message: '请选择归属课程！', type: 'warning' })
                return
            }
            // if(this.$isEmpty(this.form.courseChildNode)){
            //   this.$message({message: '请选择归属章节！',type: 'warning'});
            //   return;
            // }
            if (this.$isEmpty(this.form.handsOnName)) {
                this.$message({ message: '请输入案例名称！', type: 'warning' })
                return
            }
            if (this.$isEmpty(this.form.handsOnRecommend)) {
                this.$message({ message: '请输入案列简介！', type: 'warning' })
                return
            }
            let param = {
                teacherOpenCourseId: this.courseId,
                courseInfoId: this.form.teacherOpenCourseId, //归属课程
                courseChildNode: this.form.courseChildNode,//归属章节
                handsOnName: this.form.handsOnName,//实操名称
                handsOnRecommend: this.form.handsOnRecommend,//实操介绍
                trainingData: JSON.stringify(this.form.trainingData),//数据集
            }
            let url = "/api/teacherOpenCourseHandsOn/add.do"
            if (!this.$isEmpty(this.handsOnId)) {
                url = "/api/teacherOpenCourseHandsOn/edit.do"
                param.handsOnId = this.handsOnId
            }
            this.$post(url, param).then((ret) => {
                if (ret.code == 0) {
                    if (this.$isEmpty(this.handsOnId)) {
                        this.handsOnId = ret.data
                    }
                    this.$message({ type: 'success', message: '保存成功！' })
                } else {
                    this.$message({ message: ret.msg, type: 'error' })
                }
            })

        },
        closePage() { //返回
            this.$router.go(-1)
        },
        handleRemove(file, fileList) {
            console.log(file, fileList)
        },
        handlePreview(file) {
            console.log(file)
        },
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${file.name}？`)
        },
        selectQuestion() { //题库选择 tableSeeQuestion
            this.seeQuestionShow = Object.assign(false, true)
        },
        getCourseList() { //获取课程
            getCourseList().then((ret) => {
                if (ret.code == 0) {
                    this.courseList = ret.data
                }
            })
        },
        getCourseInfoList() { //获取章节
            getCourseInfoList({ teacherOpenCourseId: this.form.teacherOpenCourseId }).then((ret) => {
                if (ret.code == 0) {
                    this.courseInfoList = ret.data
                }
            })
        },
        getPageList() { //获取实训任务列表
            if (!this.$isEmpty(this.handsOnId)) {
                this.$post("/api/teacherOpenCourseHandsOnSimulationTasks/getPageList.do", { handsOnId: this.handsOnId }).then((ret) => {
                    if (ret.code == 0) {
                        this.tableData = ret.data
                    } else {
                        this.$message({ message: ret.msg, type: 'error' })
                    }
                })
            }
        },
        getTaskInfo(param) { //获取实训任务信息
            this.$get("/api/teacherOpenCourseHandsOnSimulationTasks/getInfo.do", param).then((ret) => {
                if (ret.code == 0) {
                    this.taskInfoForm = {
                        taskId: ret.data.taskId,
                        taskList: ret.data.taskList,
                        taskType: ret.data.taskType,
                        taskTitle: ret.data.taskTitle,
                        taskScore: ret.data.taskScore,
                        taskOrder: ret.data.taskOrder,
                        assessmentContent: ret.data.assessmentContent,
                        assessmentRequirements: ret.data.assessmentRequirements,
                        assessmentTime: ret.data.assessmentTime,
                        teacherOpenCourseHandsOnSimulationTasksFileList: ret.data.teacherOpenCourseHandsOnSimulationTasksFileList
                    }
                    if (ret.data.taskType == 5) {
                        setTimeout(() => {
                            this.$refs.richText5.content = ret.data.assessmentContent
                        }, 10)
                    }
                    this.tableQuestionData = ret.data.handsOnTaskProblemVo
                    this.taskInfoForm = Object.assign({}, this.taskInfoForm)
                    this.tableData4 = ret.data.teacherOpenCourseHandsOnSimulationTasksAssessmentList || []
                    this.addTaskShow = true
                } else {
                    this.$message({ message: ret.msg, type: 'error' })
                }
            })
        },
        editInfo(item) { //编辑实训任务
            this.getTaskInfo({ taskId: item.taskId })
        },
        delInfo(item, i) { //删除实训任务
            this.$confirm('是否确定删除该数据?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$post("/api/teacherOpenCourseHandsOnSimulationTasks/delete.do", { ids: item.taskId }).then((ret) => {
                    if (ret.code == 0) {
                        this.tableData.splice(i, 1)
                        this.$message({ type: 'success', message: '删除成功！' })
                    } else {
                        this.$message({ message: ret.msg, type: 'error' })
                    }
                })
            }).catch(() => {
                this.$message({ message: '已取消', type: 'info' })
            })
        },
        addTask() { //新增任务
            this.taskInfoForm = {
                taskType: "1",
                taskList: "",
                teacherOpenCourseHandsOnSimulationTasksFileList: []
            }
            this.tableQuestionData = []
            this.tableData4 = []
            this.addTaskShow = true
        },
        submitAddTask() { //保存新增任务
            if (this.$isEmpty(this.taskInfoForm.taskTitle)) {
                this.$message({ message: '请输入任务标题！', type: 'warning' })
                return
            }
            if (this.taskInfoForm.taskType == 1 || this.taskInfoForm.taskType == 2 || this.taskInfoForm.taskType == 5) {
                if (this.$isEmpty(this.taskInfoForm.taskScore)) {
                    this.$message({ message: '请输入分值！', type: 'warning' })
                    return
                }
                if (this.taskInfoForm.taskType == 1 || this.taskInfoForm.taskType == 2) {
                    if (this.$isEmpty(this.taskInfoForm.assessmentRequirements)) {
                        this.$message({ message: '请输入考核要求-观看时间！', type: 'warning' })
                        return
                    }
                    if (this.$isEmpty(this.taskInfoForm.assessmentTime)) {
                        this.$message({ message: '请输入考核要求-弹窗时间！', type: 'warning' })
                        return
                    }
                }
            }
            // if(this.$isEmpty(this.taskInfoForm.taskOrder)){
            //   this.$message({message: '请输入任务顺序！',type: 'warning'});
            //   return;
            // }
            let param = this.taskInfoForm,
                url = "/api/teacherOpenCourseHandsOnSimulationTasks/add.do"
            if (!this.$isEmpty(param.taskId)) {
                url = "/api/teacherOpenCourseHandsOnSimulationTasks/edit.do"
            }
            param.handsOnId = this.handsOnId
            param.teacherOpenCourseId = this.courseId
            //1:视频 2:ppt 3:理论 4:实操 5:报告
            if (this.taskInfoForm.taskType == 1 || this.taskInfoForm.taskType == 2 || this.taskInfoForm.taskType == 5) {
                if (param.teacherOpenCourseHandsOnSimulationTasksFileList.length <= 0) {
                    this.$message({ message: '请上传考核文件！', type: 'warning' })
                    return
                }
                // param.fileUrl = JSON.stringify(param.fileUrl);
                param.teacherOpenCourseHandsOnSimulationTasksFile = JSON.stringify(param.teacherOpenCourseHandsOnSimulationTasksFileList)
            }
            if (this.taskInfoForm.taskType == 3) { //理论任务时，获取题库信息
                if (this.tableQuestionData.length <= 0) {
                    this.$message({ message: '请选择题目！', type: 'warning' })
                    return
                }
                try {
                    param.taskScore = 0
                    this.tableQuestionData.forEach((item, i) => {
                        if (item.questionScore <= 0) {
                            param.taskScore = 0
                            throw new Error('请输入题目分值！')
                        }
                        param.taskScore = Number(param.taskScore) + Number(item.questionTotal)
                    })
                } catch (e) {
                    this.$message.warning(e.message)
                    return
                };
                param.handsOnTaskProblemVo = JSON.stringify(this.tableQuestionData)
            }
            if (this.taskInfoForm.taskType == 4 || this.taskInfoForm.taskType == 5) {
                if (this.$isEmpty(this.taskInfoForm.assessmentContent)) {
                    this.$message({ message: this.taskInfoForm.taskType == 4 ? '请输入考核内容！' : "请输入报告要求！", type: 'warning' })
                    return
                }
            }
            if (this.taskInfoForm.taskType == 4) { //实训操作步骤
                if (this.tableData4.length <= 0) {
                    this.$message({ message: '请添加考核题目！', type: 'warning' })
                    return
                }
                try {
                    param.taskScore = 0
                    this.tableData4.forEach((item, i) => {
                        // handsOnSimulationTasksAssessmentQuestion:"", //考核题目
                        // handsOnSimulationTasksAssessmentAnswer:"", //考核答案
                        // handsOnSimulationTasksAssessmentScore:"", //考核分值
                        if (this.$isEmpty(item.handsOnSimulationTasksAssessmentQuestion) ||
                            this.$isEmpty(item.handsOnSimulationTasksAssessmentAnswer) ||
                            this.$isEmpty(item.handsOnSimulationTasksAssessmentScore)) {
                            param.taskScore = 0
                            throw new Error('请先完善考核信息！')
                        }
                        param.taskScore = Number(param.taskScore) + Number(item.handsOnSimulationTasksAssessmentScore)
                    })
                } catch (e) {
                    this.$message.warning(e.message)
                    return
                };
                param.teacherOpenCourseHandsOnSimulationTasksAssessment = JSON.stringify(this.tableData4)
            }
            param.teacherOpenCourseHandsOnSimulationTasksFileList = []
            this.$post(url, param).then((ret) => {
                if (ret.code == 0) {
                    this.$message({ type: 'success', message: '操作成功！' })
                    this.addTaskShow = false
                    this.getPageList()
                } else {
                    this.$message({ message: ret.msg, type: 'error' })
                }
            })
        },
        getObjectiveProblem() { //获取题目的类型及数量
            if (this.$isEmpty(this.taskInfoForm.taskList)) {
                this.tableQuestionData = []
                return
            }
            let param = { problemIds: this.taskInfoForm.taskList }
            this.$get("/jlw/teacherOpenCourseHandsOnSimulationTasks/getObjectiveProblem.do", param).then((ret) => {
                this.tableQuestionData = ret
            })
        },
        taskInfoSuccess(file) { //上传成功回调
            this.taskInfoForm.teacherOpenCourseHandsOnSimulationTasksFileList = []
            for (let i in file) {
                this.taskInfoForm.teacherOpenCourseHandsOnSimulationTasksFileList.push(
                    {
                        fileName: file[i].name,
                        fileUrl: file[i].url,
                    })
            }
        },
        questionSuccess(ids) { //选题成功回调
            this.taskInfoForm.taskList = ids
            this.getObjectiveProblem()
        },
        changeInfo(item, i) { //分值自定义，计算总分
            item.questionTotal = item.questionScore * item.questionNum
            console.log(item)
        },
        getSummaries(param) {
            return this.$getSummaries(param)
        },
        arraySpanMethod({ row, column, rowIndex, columnIndex }) {
            this.$arraySpanMethod(this.$refs.tableQuestion.$el, '3')
        },
        addSubject() { //添加考核题目答案
            this.tableData4.push({
                handsOnId: this.handsOnId,//实操ID
                handsOnSimulationTasksAssessmentQuestion: "", //考核题目
                handsOnSimulationTasksAssessmentAnswer: "", //考核答案
                handsOnSimulationTasksAssessmentScore: "", //考核分值
            })
        },
        delSubject(index) { //删除考核题目信息
            this.tableData4.splice(index, 1)
        },
        changeValue(val) { // 实操考核内容 根据内容信息显示考核题目【根据[---]区分，一个[---]表示一个题目】
            this.taskInfoForm.assessmentContent = val
            if (!this.$isEmpty(val) && val.indexOf("[---]") >= 0) {
                if (this.tableData4.length > val.split("[---]").length - 1) {
                    this.tableData4 = this.tableData4.slice(0, val.split("[---]").length - 1)
                } else if (this.tableData4.length < val.split("[---]").length - 1) {
                    let n = val.split("[---]").length - this.tableData4.length
                    for (let i = 0; i < n - 1; i++) {
                        this.tableData4.push({
                            handsOnId: this.handsOnId,//实操ID
                            handsOnSimulationTasksAssessmentQuestion: this.$chineseNum(this.tableData4.length, 1), //考核题目
                            handsOnSimulationTasksAssessmentAnswer: "", //考核答案
                            handsOnSimulationTasksAssessmentScore: "", //考核分值
                        })
                    }

                }
            } else {
                this.tableData4 = []
            }
        },
        openResourceLibrary() { //资源库上传
            this.limit = 10
            this.page = 1
            this.total = 0
            this.tablePool = []
            this.poolSearch.name = ""
            this.poolSearch.courseInfoId = ""//this.form.teacherOpenCourseId
            this.uploadPoolShow = true
            this.courseInfoPageByUniColleges(1)
        },
        courseInfoPageByUniColleges(typeInfo) { //获取归属课程
            // this.$post("/api/courseInfo/courseInfoPageByUniCollegesId.do").then((ret) =>{
            //courseType  0（开课课程）1（授权课程）
            this.$get("/jlw/universitiesCollegesJurisdictionCurriculumResources/getTheoryAddOpenCourseList.json?teacherOpenCourseId=" + this.courseId + '&courseType=1').then((ret) => {
                if (ret.code == 0) {
                    this.courseImportList = ret.data
                    if (typeInfo == 1 && this.courseImportList.length > 0) {
                        this.poolSearch.courseInfoId = this.courseImportList[0].courseInfoId
                        this.getPoolInfo()
                    }
                }
            })
        },
        getPoolInfo() { //获取资源列表
            let param = {
                limit: this.limit,
                page: this.page,
                resourcesInfoName: this.poolSearch.name,
                courseInfoIds: this.poolSearch.courseInfoId,
                resourcesInfoTypePlural: this.taskInfoForm.taskType == 1 ? 1 : this.taskInfoForm.taskType == 2 ? '2,3' : ''
                //resourcesInfoType:this.taskInfoForm.taskType == 1?1:3
            }
            this.$post("/jlw/resourcesInfo/getResourceSystemOAndUniversitiesList.json", param).then((ret) => {
                if (ret.code == 0) {
                    this.total = Number(ret.count)
                    this.tablePool = ret.data
                } else {
                    this.$message({ message: ret.msg, type: 'error' })
                }
            })
        },
        selectPoolInfo(item) { //确定选择资源库资源 //1	视频 2	PPT 3	PDF 4	链接 5	图文
            this.taskInfoForm.teacherOpenCourseHandsOnSimulationTasksFileList.push(
                {
                    fileName: item.resourcesInfoName,
                    fileUrl: item.resourcesInfoContent,
                })
            // this.taskInfoForm = Object.assign({}, this.taskInfoForm);
            // this.addTaskShow = Object.assign(false,true);

            this.$refs.taskPicture.fileList.push({
                name: item.resourcesInfoName,
                url: item.resourcesInfoContent,
            })
            this.uploadPoolShow = false
        },
        lookPoolInfo(item) { //查看资源库资源
            if (item.resourcesInfoType == 4) {
                window.open(item.resourcesInfoContent.indexOf("http") == 0 ? item.resourcesInfoContent : "http://" + item.resourcesInfoContent)
                return
            } else {
                this.$ls.set(this.$getKeyInfo("TCoursewareViewingInfo"), item)
                this.$router.push({ name: 'TCoursewareViewing' })
            }

        },
        handleSizeChange(val) {
            this.limit = val
            this.getPoolInfo()
        },
        handleCurrentChange(val) {
            this.page = val
            this.getPoolInfo()
        },
    }
}
</script>
<style lang="less">
.el-AddPractical {
    padding: 20px 20px 0;

    .content_block {
        background-color: #ffffff;
    }
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/Teacher/AddPractical.vue